import gql from 'graphql-tag'
import {
  RemoveUserModal_group,
  RemoveUserModal_user
} from './components/RemoveUserModal.fragments'

export default gql`
  query RouteAdminFeaturesGroupUsersQuery($groupId: ID!, $userCount: Int!) {
    group(groupId: $groupId) {
      id
      ...RemoveUserModal_group

      users(first: $userCount)
        @connection(key: "RouteAdminFeaturesGroupUsers_users") {
        edges {
          node {
            id
            email
            firstName
            lastName

            ...RemoveUserModal_user
          }
        }
      }
    }
  }

  ${RemoveUserModal_group}
  ${RemoveUserModal_user}
`



// WEBPACK FOOTER //
// ./src/routes/admin/features/group/users.query.js